<nav class="sidebar">
  <ul id="iq-sidebar-toggle" class="iq-menu">
    <ng-container *ngIf="showSpinner">
      <div *ngIf="showSpinner">
        <div class="spinner-container"></div>
        <p-progressSpinner strokeWidth="5" class="spinner"></p-progressSpinner>
      </div>
    </ng-container>
    <!-- for client login-->
    <ng-container *ngIf="showMenu && isClient">
      <ng-container *ngIf="sideMenuData">
        <li *ngFor="let item of sideMenuData">
          <a href="javascript:void(0)" (click)="buildAPP(item.name,item.name,item?.url)" class="collapsed" data-toggle="collapse" aria-expanded="false">
            <i class="leftmenu-icon {{item.name | lowercase }}"></i>
            <span class="menu-title">{{item.name}}</span>
          </a>
        </li>
      </ng-container>
    </ng-container>
    <!-- for not client login-->
    <ng-container *ngIf="showMenu && !isClient">
      <li>
        <a href="#home" (click)="buildAPP('home','HOMEAPPURL','/home')" class="collapsed" data-toggle="collapse"
          aria-expanded="false">
          <i class="leftmenu-icon home"></i>
          <span class="menu-title">Home</span>
          <i class="pi pi-angle-right"></i>
        </a>
        <ul id="home" class="submenu collapse" data-parent="#iq-sidebar-toggle">
          <li *ngIf="dashboardStatus === true"><a (click)="buildAPP('home','HOMEAPPURL','/dashboard')">Dashboard</a></li>
          <li><a (click)="buildAPP('home','HOMEAPPURL','/tasks')">My Open Tasks</a></li>
          <li *ngIf="eLogBookStatus === true"><a (click)="buildAPP('home','HOMEAPPURL','/eLogBook')">E-Log Book</a></li>
          <li *ngIf="sendValueStatus === true"><a href="{{proposalUrl}}#/dashboard/{{secrectKey}}" target="_blank">Proposal</a></li>
        </ul>
      </li>
      <ng-container *ngIf="sideMenuData && showBlankMenu">
        <li *ngFor="let item of MainKeys">
          <a href="#{{item | lowercase | removeWhitespace}}" class="collapsed" data-toggle="collapse" aria-expanded="false">
            <i class="leftmenu-icon {{item | lowercase }}"></i>
            <span class="menu-title">{{item}}</span>
            <i class="pi pi-angle-right"></i>
          </a>
          <ng-container *ngIf="sideMenuData[item]">
            <ul id="{{item | lowercase | removeWhitespace}}" class="submenu collapse" data-parent="#iq-sidebar-toggle">
              <!-- <ng-container *ngIf="item == 'Clients'"> -->
              <li *ngFor="let subMenu of sideMenuData[item]"><a
                  (click)="buildAPP(item,item,subMenu?.url)">{{subMenu?.submenu_name}}</a></li>
            </ul>
          </ng-container>
        </li>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showMenu">
      <li>
        <a href="#feedback" class="collapsed" data-toggle="collapse"
          aria-expanded="false">
          <i class="leftmenu-icon operations"></i>
          <span class="menu-title">Feedback</span>
          <i class="pi pi-angle-right"></i>
        </a>
        <ul id="feedback" class="submenu collapse" data-parent="#iq-sidebar-toggle">
          <li><a id="user_feedback" href="javascript:void(0)" (click)="centerlizeTheFeedBackForm()">Report Feedback</a></li>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>